module.exports = __webpack_public_path__ + "images/uploadSdkIcon-36b0270df0d2d538d60e74f784b02ff0.svg";